<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Winst uit onderneming
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                De vragen over winst uit onderneming zijn alleen van toepassing als een belastingplichtige ondernemer is
                voor de inkomstenbelasting.

                <div class="space20"></div>

                <b>Wanneer is iemand ondernemer voor de inkomstenbelasting?</b><br/>
                Als ondernemer meldt iemand zich eerst bij de Kamer van Koophandel, voor de inschrijving in het
                Handelsregister. De Kamer van Koophandel geeft de gegevens aan de Belastingdienst door. De inschrijving
                bij de Kamer van Koophandel betekent niet dat de persoon ook ondernemer is voor de inkomstenbelasting.
                Aan de hand van de omstandigheden beoordelen de Belastingdienst of de persoon ondernemer is.

                <div class="space20"></div>

                Lang niet iedereen die ondernemer wil zijn, is ondernemer voor de inkomstenbelasting. Als de
                activiteiten zich afspelen in het economisch verkeer en als de persoon winst kan verwachten, is die
                persoon mogelijk ondernemer voor de inkomstenbelasting. Als de activiteiten zich afspelen binnen de
                hobby- of familiesfeer, is de persoon geen ondernemer voor de inkomstenbelasting. Voor
                belastingplichtigen heeft de belastingdienst een handig hulpmiddel om te checken of er sprake is van
                ondernemerschap voor de inkomstenbelasting: de <a
                    href="https://www.belastingdienst.nl/wps/wcm/connect/nl/ondernemers/content/hulpmiddel-checken-of-ik-ondernemer-ben-voor-de-inkomstenbelasting">OndernemersCheck</a>.

                <div class="space20"></div>

                <b>Welke aspecten spelen een rol bij de beoordeling?</b><br/>
                Bij het beoordelen of iemand ondernemer is voor de inkomstenbelasting, let de Belastingdienst
                bijvoorbeeld op:<br/>

                <li class="list">Maakt de persoon winst? Zo ja, hoeveel?<br/>
                    Als iemand alleen een heel kleine winst heeft of structureel verlies lijdt, is het niet aannemelijk
                    dat hij winst gaat maken. Er is dan geen sprake van een onderneming.
                </li>
                <li class="list">Hoe zelfstandig is de onderneming?<br/>
                    Als anderen bepalen hoe iemand de onderneming moet inrichten en hoe hij de werkzaamheden uitvoert,
                    ontbreekt de zelfstandigheid en is er meestal geen sprake van een onderneming.
                </li>
                <li class="list">Beschikt iemand over kapitaal?<br/>
                    Kapitaal is voor veel ondernemingen noodzakelijk. De betrokkene moet investeren in bijvoorbeeld
                    reclame, inhuur van mensen en verzekeringen. Voldoende kapitaal om een onderneming te starten en
                    enige tijd draaiende te houden, wijst erop dat iemand mogelijk een onderneming hebt.
                </li>
                <li class="list">Hoeveel tijd steekt iemand in deu werkzaamheden?<br/>
                    Als iemand erg veel tijd aan een activiteit besteedt zonder dat dat rendement oplevert, is er
                    meestal geen sprake van een onderneming. De persoon moet daarentegen wel voldoende tijd aan de
                    werkzaamheden besteden om deze rendabel te maken.
                </li>
                <li class="list">Wie zijn de opdrachtgevers?<br/>
                    De persoon streeft ernaar meerdere opdrachtgevers te hebben, onder andere om betalings- en
                    continuïteitsrisico's te verminderen. Wanneer er meerdere opdrachtgevers zijn, neemt de
                    afhankelijkheid van 1 of enkele opdrachtgevers af en neemt de zelfstandigheid toe.
                </li>
                <li class="list">Hoe maakt iemand de onderneming bekend naar buiten?<br/>
                    Iemand is voor het bestaan afhankelijk van opdrachtgevers. Om ondernemer te zijn, moet iemand zich
                    voldoende kenbaar maken, bijvoorbeeld door reclame, een website, een uithangbord of eigen
                    briefpapier.
                </li>
                <li class="list">Loopt de persoon 'ondernemersrisico'?<br/>
                    Bestaat er een kans dat de opdrachtgevers niet betalen? Gebruikt iemand zijn goede naam voor de
                    uitoefening van je werkzaamheden? Is de persoon afhankelijk van de vraag naar en het aanbod van de
                    producten en diensten? Loopt iemand 'ondernemersrisico', dan is er waarschijnlijk sprake van een
                    onderneming.
                </li>
                <li class="list">Is iemand aansprakelijk voor de schulden van de onderneming?<br/>
                    Als de persoon aansprakelijk is voor de schulden van de onderneming, dan is die persoon mogelijk
                    ondernemer.
                </li>

            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading13">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse13" aria-expanded="false" aria-controls="collapse13">
                Ondernemingsvorm
            </button>
        </h2>
        <div id="collapse13" class="accordion-collapse collapse" aria-labelledby="heading13"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Een van de vragen in het aangifteformulier gaat over de ondernemingsvorm.

                <div class="space20"></div>
                <b>Eenmanszaak</b><br/>
                Bij een eenmanszaak drijft de ondernemer de onderneming alleen. Dit is het geval als hij/zij een zelfstandig beroep
                uitoefent (bijvoorbeeld notaris of huisarts) of als hij/zij de enige eigenaar van het bedrijf is. Er kan dus
                ook een eenmanszaak hebben als er personeel in dienst is.
                <div class="space20"></div>

                <b>Samenwerkingsverband</b><br/>
                Als de onderneming een samenwerkingsverband is, dan kun je gegevens op verschillende wijze in de
                aangifte vermelden. Op dit moment zijn deze opties nog mogelijk. Wil je wel voor bijv. een firmant het
                verzoek of wijziging voorlopige aanslag invullen, kies dan voor 'Eenmanszaak'.
                <div class="space10"></div>
                1. Persoonlijk niveau<br/>
                Je vult de winst-en-verliesrekening en de balans in op persoonlijk niveau. Daarbij ga je alleen uit van
                het aandeel in het samenwerkingsverband.
                <div class="space10"></div>
                2. Samenwerkingsverband<br/>
                Je vult de winst-en-verliesrekening en de balans in op het niveau van het samenwerkingsverband.
                Bovendien specificeer je het kapitaal- en winstaandeel in het samenwerkingsverband. Hiermee herleid je
                de cijfers van de vennootschap onder firma, de maatschap of een ander samenwerkingsverband naar een
                persoonlijke aangifte.

                <div class="space10"></div>
                3. Buitenvennootschappelijk ondernemingsvermogen<br/>
                Was er ook buitenvennootschappelijk ondernemingsvermogen? Als je de winst-en-verliesrekening op
                persoonlijk niveau invult, verwerk je deze vermogensbestanddelen in de balans op persoonlijk niveau.
                Vul je de winst-en-verliesrekening en de balans in op het niveau van het samenwerkingsverband? Dan moet
                je het buitenvennootschappelijk vermogen afzonderlijk aangeven.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                Winst uit onderneming als medegerechtigde of schuldeiser
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Is de belastingplichtige niet hoofdelijk aansprakelijk voor de schulden van de onderneming? En kan hij
                voor de onderneming ook geen bindende afspraken maken? Dan is de belastingplichtige meestal
                mede-gerechtelijk in een onderneming. Dat is bijvoorbeeld het geval als hij commanditair vennoot was in
                een commanditaire vennootschap. Hij loopt dan alleen risico dat hij het bedrag van het commanditaire
                kapitaal kwijtraakt.

                <div class="space20"></div>

                Leende de belastingplichtige geld aan een ondernemer en functioneerde deze lening in feite als eigen
                vermogen van de onderneming? Of was de vergoeding voor de lening sterk afhankelijk van de winst van de
                onderneming? Dan is er sprake van winst uit onderneming.

                <div class="space20"></div>

                Als medegerechtigde of geldverstrekker krijgt belastingplichtige geen ondernemersaftrek en
                mkb-winstvrijstelling.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Boekjaar - gebroken boekjaar
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <b>Boekjaar</b><br/>
                Als ondernemer of zzp'er ben je verplicht om de winst die je maakt op te geven in de aangifte
                inkomstenbelasting voor het kalenderjaar waarin die winst is behaald.

                Soms is het echter zo dat je een seizoensgebonden bedrijf hebt, waarbij de producten die je aanbiedt,
                afhankelijk zijn van het seizoen. In zo'n geval is het niet altijd praktisch om je winst per
                kalenderjaar op te geven. Er kan dan gebruik gemaakt worden van een gebroken boekjaar.

                <div class="space20"></div>

                <b>Gebroken boekjaar winstaangifte</b><br/>
                Als de onderneming een seizoensgebonden bedrijf betreft, mag de ondernemer in de winstaangifte een
                zogenaamd "gebroken boekjaar" gebruiken. Dit betekent dat hij de winst kan opgeven over een periode die
                bijvoorbeeld loopt van juli tot en met juni van het volgende jaar.

                <div class="space20"></div>

                Let op dat iemand niet zomaar in aanmerking komt voor een gebroken boekjaar. De aard van de onderneming
                moet dit rechtvaardigen en er moet een nauwkeurige boekhouding bijgehouden worden.

                <div class="space20"></div>

                <b>Welke winst aangeven bij een gebroken boekjaar?</b><br/>
                Wanneer je dan de aangifte inkomstenbelasting invult, moet je de winst opgeven in het jaar waarin het
                gebroken boekjaar eindigt. Dus als het boekjaar loopt van juli {{ this.actualYear - 1 }} tot en met
                juni {{ this.actualYear }}, dan geef je de winst op in het jaar {{ this.actualYear }}.
            </div>
        </div>
    </div>

</div>

